import { mapState, mapActions, mapGetters } from 'vuex'
import predicates from '@/module/filter/predicate'
import eventId from '@/module/util/event-id'

const SORT_INDEX = [
    { id: 'appointment', text: 'Appointment'},
	{ id: 'clinical_data_activity', text: 'Last Activity' },
	{ id: 'name', text: 'First Name' },
	{ id: 'last', text: 'Last Name' }
]

const SORT_INDEX_FOR_OBSERVER = [
    { id: 'appointment', text: 'Appointment'},
	{ id: 'name', text: 'Name' }
]


export default {
    props: {
        type: {
            type: String,
            default: 'patient'
        },
        label: {
            type: String
        },
		filter: {
			type: String
		},
        url: {
            type: String,
            required: true
        },
        patientList: {
            type: Array
        },
        listTitle: {
            type: String
        },
    },


    data() {
        return {
            // Search string that fiters patients to be shown
            search: '',
            sort: 'appointment',
            order: 'name',
            sortIndex: SORT_INDEX,
            sortIndexForObserver: SORT_INDEX_FOR_OBSERVER
        }
    },



    methods: {
        ...mapActions('provider', [
            'loadPatients'
        ]),

        activePatient(patient) {
            return this.routeName.includes(patient.id)
        },

		displayPatient(patient) {
			if (! this.filterData)
				return false

			var filterArg = {}
			if (this.filterArg) {
				if (this.filterArg.start) {
					filterArg.start = new Date(this.filterArg.start).getTime()
					filterArg.startEvent = eventId(filterArg.start, 0)
				}
				if (this.filterArg.end) {
					filterArg.end = new Date(this.filterArg.end).getTime()
					filterArg.endEvent = eventId(filterArg.end, 1)
				}
			}

			var predicate
			for (var i = 0 ; i < this.filterData.predicate.term.length ; i++) {
				predicate = this.filterData.predicate.term[i].predicate
				if (predicate.match && ! predicate.match(patient, predicate.arg, filterArg, this.getCurrentProvider))
					return false
			}

			return true
		},

		getPredicate(predicate) {
			let group = predicates.find((p) => (p.option.value === predicate.id[0]))
			if (group && group.option && group.option.children && predicate.id.length > 1) {
				return group.option.children.find((child) => (child.value === predicate.id[1]))
			}
			return null
		},

        setSort(sort) {
            this.sort = sort
        },

        upcomingMapingData() {
            if(this.routeName.includes('today'))
                return 'Appt - Today'
            else if(this.routeName.includes('tomorrow'))
                return 'Appt - Tomorrow'
            else if(this.routeName.includes('next_seven'))
                return 'Appt - Next 7 days'
            else if(this.routeName.includes('last_seven'))
                return 'Appt - Past 7 days'
            else if(this.routeName.includes('last_fourteen'))
                return 'Appt - Past 14 days'
            return ''
        },
        tagMapingData () {
            let tagId = ''
            let tempRouteSplitArray = this.routeName.split('/')
            if (tempRouteSplitArray.length >= 3) tagId = tempRouteSplitArray[2]
            return this.getTagName(tagId)
        },
        getLastName(name) {
            let arr = name.split(' ')
            return arr[0] + ' ' + arr[arr.length - 1]
        },
        getTagName(tag) {
			let tagObj = this.getTagToColorMapping.filter(obj => obj.id === tag)
            if (tagObj.length)  return tagObj[0].name
            else return ''
        },
        getSlicedName(name) {
            const sliced = name && name.slice(0, 18)
            if(name && name.length > 18)
                return sliced + '...'
            return sliced
        },
        locationWisePatients(day, currLocation) {
            let cnt = 0
            let otherCnt = 0
            let upcomingMappedSchedule = this.overview && this.overview.schedule_map

            if (currLocation === 'Other') {
                Object.values(upcomingMappedSchedule).forEach((obj) => {
                    if (!obj.hasOwnProperty('location')) otherCnt++
                })
                return otherCnt
            }

            let dayProviderEvent = this.overview && 
                                    this.overview.schedule && 
                                    this.overview.schedule[day] && 
                                    this.overview.schedule[day][this.getCurrentProvider]

            for(let locationObj in upcomingMappedSchedule) {
                if (dayProviderEvent.includes(locationObj) && upcomingMappedSchedule[locationObj].location === currLocation)
                    cnt++
            }
            return cnt
        },
        eventOnlyWisePatients(day, currEvent) {
            let cnt = 0
            let upcomingMappedSchedule = this.overview && this.overview.schedule_map
            let dayProviderEvent = this.overview && 
                                    this.overview.schedule && 
                                    this.overview.schedule[day] && 
                                    this.overview.schedule[day][this.getCurrentProvider]
            for(let eventObj in upcomingMappedSchedule) {
                if (dayProviderEvent.includes(eventObj) && upcomingMappedSchedule[eventObj].event === currEvent) cnt++
            }
            return cnt
        },
        eventWisePatients(day, currLocation, currEvent) {
            let cnt = 0
            let otherCnt = 0
            let upcomingMappedSchedule = this.overview && this.overview.schedule_map
            let dayProviderEvent = this.overview && 
                                    this.overview.schedule && 
                                    this.overview.schedule[day] && 
                                    this.overview.schedule[day][this.getCurrentProvider]

            if (currLocation === 'Other') {
                for(let eventObj in upcomingMappedSchedule) {
                    if (dayProviderEvent.includes(eventObj) && 
                        upcomingMappedSchedule[eventObj].event === currEvent && 
                        !upcomingMappedSchedule[eventObj].hasOwnProperty('location')) 
                        otherCnt++
                }
                return otherCnt
            }
            for(let eventObj in upcomingMappedSchedule) {
                if (dayProviderEvent.includes(eventObj) && 
                    upcomingMappedSchedule[eventObj].event === currEvent &&
                    upcomingMappedSchedule[eventObj].location === currLocation ) cnt++
            }
            return cnt
        },
        isPastSchedule(key) {
            let found = false
            if (!this.getCurrentProvider) {
                let ranges = Object.keys(this.overview.schedule).filter((filterRange) => filterRange === 'last_seven' || filterRange === 'last_fourteen')
                ranges.forEach(filterRange => {
                    Object.keys(this.overview.schedule[filterRange]).forEach((provider) => {
                        this.overview.schedule[filterRange][provider].forEach((schedule) => {
                            if (schedule === key) found = true
                        })
                    })
                
                })
            } else {
                Object.keys(this.overview.schedule).filter((filterRange) => filterRange === 'last_seven' || filterRange === 'last_fourteen')
                .forEach((filterRange) => {
                    this.overview.schedule[filterRange][this.getCurrentProvider].forEach((schedule) => {
                        if (schedule === key) found = true
                    })
                })
            }
            return found
        }
    },

    computed: {
        ...mapState(['routeName']),
        ...mapState('provider', [
            'loadingPatients',
            'patient',
            'allPatients',
            'providerPatients',
            'filters',
            'siteOverview',
            'overview'
        ]),
        // Global getters
        ...mapGetters('provider', [
			'getProvider',
			'getCurrentProvider',
            'getPatientList',
            'searchPatients',
            'getFilterArg',
            'getAllProviderPatientList',
            'getProvidersIdArray',
            'getTagToColorMapping'
        ]),
        ...mapGetters(['getUserType']),
        ...mapGetters("content", ["getContentKey"]),

		provider() {
			return this.getProvider
		},

		filterArg() {
			return this.getFilterArg(this.filter)
		},

		filterData() {
			var data
			if (this.filters && this.getCurrentProvider && this.filters[this.getCurrentProvider]) {
				data = this.filters[this.getCurrentProvider].find((filter) => filter.id === this.filter)
				if (data) {
					data.predicate.term.forEach((term) => {
						Object.assign(term.predicate, this.getPredicate(term.predicate))
					})
				}
			}
			return data
		},

		searchQuery() {
			return this.search.toLowerCase()
		},

        population() {
            return this.getPatientList
        },

        displayPopulation() {
            let pop = []
            if(!this.getCurrentProvider)
                pop = this.getAllProviderPatientList
            else {
                const currentproviderPatients = this.providerPatients.find(({ id }) => id === this.getCurrentProvider)
                pop = currentproviderPatients ? currentproviderPatients.patient : []
            }
            pop.forEach((member) => {
                if (member.previous_schedule && this.overview.schedule_map) {
                    // Uses Overview schedule_map to map previous schedule instead of linedown api
                    let schedule = Object.keys(this.overview.schedule_map)
                                .filter((key) => this.overview.schedule_map[key].auth === member.id && this.isPastSchedule(key))
                                .map((key) => this.overview.schedule_map[key].time)
                                .sort((a, b) => b - a)
                    member.previous_schedule = schedule[0]
                }
            })
            pop = pop
                .filter((member) => (this.label == null ||
                    (Array.isArray(member.label) && member.label.includes(this.label))) &&
                    (this.filter == null || this.displayPatient(member)))
                .filter((member) => (!this.patientList ||
                    this.patientList.includes(member.id)) &&
                    (this.search.length < 3 ||
                    // Filter out patients which are not part of `search`
                    (member.name ? member.name.toLowerCase().includes(this.searchQuery) : false))
                )
                .sort(this.orderingFunction)
            return pop
        },

        /**
         * @function 	orderingFunction
         * @desc 		Returns the ordering function used to sort patients.
         */
        orderingFunction() {
            // Sort by activity time
            if(this.sort === 'appointment')
                return (a, b) => {
                    if(this.url.includes('backward')) {
                        return (b.previous_schedule ? b.previous_schedule : 0) - (a.previous_schedule ? a.previous_schedule : 0)
                    }
                    if(a.next_schedule || b.next_schedule) {
                        if(a.next_schedule && !b.next_schedule)
                            return -1
                        if(!a.next_schedule && b.next_schedule)
                            return 1
                        let an = a.next_schedule || 0,
                            bn = b.next_schedule || 0
                        const date1 = new Date(an)
                        const date2 = new Date(bn)
                        if(
                            date1.getFullYear() === date2.getFullYear() &&
                            date1.getMonth() === date2.getMonth() &&
                            date1.getDate() === date2.getDate()
                            ) {
                            if(an % 1000 === 123) return 1
                            if(bn % 1000 === 123) return -1
                            return an - bn
                        }
                        return an - bn
                    }
                    let at = a.activity || a.created
                    let bt = b.activity || b.created
                    if (! at) return 1
                    if (! bt) return -1
                    return bt - at
                }
            if (this.sort === 'activity')
                return (a, b) => {
                    let at = a.activity || a.created
                    let bt = b.activity || b.created
                    if (! at) return 1
                    if (! bt) return -1
                    return bt - at
                }
            if( this.sort === 'clinical_data_activity')
                return (a, b) => {
                    let at = a.clinical_data_activity || 0
                    let bt = b.clinical_data_activity || 0
                    if (! at) return 1
                    if (! bt) return -1
                    return bt - at
                }
            // Sort alphabetically by name
            else if (this.sort === 'last')
                return (a, b) => {
                    let an = a.family_name || a.name,
                        bn = b.family_name || b.name
                    if (! an) return -1
                    if (! bn) return 1
                    return an.toLowerCase().localeCompare(bn.toLowerCase())
                }
            else
                return (a, b) => {
                    if (! a.name) return -1
                    if (! b.name) return 1
                    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                }
        },

        sortDisplay() {
            let currentSortIndexArray = SORT_INDEX
            if (this.getUserType === 'observer')
                currentSortIndexArray = SORT_INDEX_FOR_OBSERVER
            return currentSortIndexArray.find((index) => index.id == this.sort)
        },

        searchPlaceholder() {
			if (this.filterData != null)
				return 'Search ' + this.filterData.name
            else if (this.label != null)
				return 'Search ' + this.label + ' patients'
			else
                return 'Search patients'
        },

		title() {
            if(this.searchQuery !== '') {
                return this.searchQuery.length < 3 ? 'Type 3 letters to search' : 'Search Results'
            }
            else if(this.listTitle && this.listTitle !== '')
                return this.listTitle
			else if (this.filterData != null)
				return this.filterData.name
            else if (this.label != null)
                return this.label + ' patients'
            else if(this.getCurrentProvider && this.getProvider) {
                let patientNo
                if(this.routeName.startsWith('/upcoming')) {
                    const day = this.routeName.split('/')[2]
                    let location = (this.routeName.split('/')[3] !== null || this.routeName.split('/')[3] !== undefined) ? this.routeName.split('/')[3] : ''
                    let event = (this.routeName.split('/')[4] !== null || this.routeName.split('/')[4] !== undefined) ? this.routeName.split('/')[4] : ''
                    if(event === 'provider') event = ''
                    if (location === 'provider') location = ''

                    let hasLocation = location && location.length > 0 && location !== 'undefined'
                    let hasEvent = event && event.length > 0

                    if (!hasLocation && hasEvent && this.getContentKey('event', event, 'name')) {
                        let evenName = this.getSlicedName(this.getContentKey('event', event, 'name'))
                        let dayEventCnt = this.eventOnlyWisePatients(day, event)
                        return evenName + ' (' + dayEventCnt + ')'
                    } else if (hasLocation && !hasEvent) {
                        let locationName = this.getSlicedName(location)
                        let dayLocationCnt = this.locationWisePatients(day, location)
                        return locationName + ' (' + dayLocationCnt + ')'
                    } else if(hasLocation && hasEvent) {
                        let evenName = this.getSlicedName(this.getContentKey('event', event, 'name'))
                        let dayEventCnt = this.eventWisePatients(day, location, event)
                        return evenName + ' (' + dayEventCnt + ')'
                    } else {
                        if(this.overview && 
                            this.overview.schedule && 
                            this.overview.schedule[day] && 
                            this.overview.schedule[day][this.getCurrentProvider])
                                patientNo = this.overview.schedule[day][this.getCurrentProvider].length
                        else patientNo = 0
                        return this.getLastName(this.getProvider.name) + ' (' + patientNo + ')'
                    }
                } else {
                    patientNo = this.siteOverview[this.getCurrentProvider] ?
                        this.siteOverview[this.getCurrentProvider].count :
                        this.displayPopulation.length 
                    
                    return this.getLastName(this.getProvider.name) + ' (' + patientNo + ')'
                }
            }
            else if(this.routeName.startsWith('/upcoming'))
                return this.upcomingMapingData()   
            else if(this.routeName.startsWith('/tag'))
                return this.tagMapingData() + ' (' + this.displayPopulation.length + ')'
			else {
                const patientNo = this.allPatientCount ? this.allPatientCount : this.displayPopulation.length
                return 'All patients (' + patientNo + ')'
            }
                
        }
    }
}
